import { Spin } from 'antd'
import React from 'react'

interface Props {
    className?: string;
}
const SectionLoader = (props: Props) => {
    return (
        <div className={`w-full h-[80px] text-center flex items-center justify-center ${props?.className || ""}`}>
            <Spin size='small' />
        </div>
    )
}

export default SectionLoader